module.exports = __webpack_public_path__ + "img/mongodb.d2d3fb25.png";